import { Environment } from '@amzn/aws-d2c-visitor-id-client';
import { getD2CClientEnv } from './env-utils';

/**
 * Logs errors.  Currently disabled outside of DEV.
 * @param val - The text or Error to log
 */
export function logErr(val: unknown): void {
  if (isDevEnvironment()) {
    console.error(val);
  }
}

/**
 * Logs non-error information.  Currently disabled outside of DEV.
 * @param val - The text or Error to log
 */
export function log(val: unknown): void {
  if (isDevEnvironment()) {
    console.log(val);
  }
}

/**
 * Checks whether we're in the DEV environment or not.
 */
const isDevEnvironment = function (): boolean {
  return Environment.DEV === getD2CClientEnv();
};
